import { Button, ButtonProps, Modal } from 'antd'
import React, { FunctionComponent } from 'react'

import { useFetchAresIco } from '../../utils/useFetchAresIco'
import { useToggleState } from '../../utils/useToggleState'
import { AresSearchIcoRegistersTable } from '../AresSearchIcoRegistersTable/AresSearchIcoRegistersTable'

export interface AresSearchIcoModalButtonProps {
  ico?: string
  buttonProps?: ButtonProps
  buttonText?: React.ReactNode
}

export const AresSearchIcoModalButton: FunctionComponent<AresSearchIcoModalButtonProps> =
  props => {
    const [open, toggleOpen] = useToggleState()
    const { fetching, data } = useFetchAresIco(open ? props.ico : undefined)

    return (
      <>
        <Button
          type="link"
          size="small"
          onClick={toggleOpen}
          {...props.buttonProps}
        >
          {props.ico || props.buttonText}
        </Button>
        {open && (
          <Modal
            title={`Výskyt v registrech pro IČO ${props.ico}`}
            open={open}
            onCancel={toggleOpen}
            footer={null}
            width={1000}
            loading={fetching}
          >
            <div className="my-4">
              <AresSearchIcoRegistersTable
                ico={props.ico}
                data={data?.seznamRegistraci}
                fetching={fetching}
              />
            </div>
          </Modal>
        )}
      </>
    )
  }
